exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".days-list[data-v-4ca10458] {\n  display: grid;\n  margin: 20px 0;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n}", ""]);

// exports
